import TurndownService from 'turndown'
import ShowdownService from 'showdown'

export const htmlToMarkdown = (htmlText = '') => {
  const turndownService = new TurndownService({
    strongDelimiter: '**',
    emDelimiter: '*',
  })

  turndownService.addRule('underline', {
    filter: 'u',
    replacement: content => `__${content}__`,
  })

  return turndownService.turndown(htmlText)
}

export const markdownToHtml = (htmlText = '') => {
  const showdownService = new ShowdownService.Converter({
    underline: true,
  })

  return showdownService.makeHtml(htmlText)
}
